import { makeStyles } from '@material-ui/core';
import arqLogo from '../../assets/MyralisArqLogo.webp';

const useStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    width: '100%',
    maxWidth: 204,
    lineHeight: 0,
  },
  image: {
    display: 'block',
    width: '100%',
    height: 'auto',
  },
});

type LogoFullProps = {
  variant?: 'default' | 'sidebar';
};

export const LogoFull = (_props: LogoFullProps) => {
  const classes = useStyles();

  return (
    <span className={classes.root} aria-label="ARQ Arquitetura Corporativa">
      <img
        className={classes.image}
        src={arqLogo}
        alt="ARQ Arquitetura Corporativa"
      />
    </span>
  );
};
